import * as React from 'react';
import * as CSSModules from 'react-css-modules';
const styles = require('./item.less');

const InPageNavItem = ({ children }) => (
    <div className="in-page-nav-item">{children}</div>
);

export default CSSModules(InPageNavItem, styles, { allowMultiple: true });
